import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as MenuAction from './MenuAction';
import * as $ from 'jquery';
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};

const GetpageLoad = (GetSearchBO) => {
    try {
       
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(GetSearchBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Searchresult", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const ImgaddAttachment = async (files) => {
    try {
        SDISVC.uploadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_AttachFiles,
            "",
            files,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Img_UploadAttachments", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

/*[06/24/22, PC_WW-390_21]Priyanka D*/
const Analytics = (AnalyticsBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.UserAnalytics,
            SDIConstants.methodNames.SendAnalytics,
            JSON.stringify(AnalyticsBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Analytics", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const AddCart = (AddCartBO) => {
    try {
  
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_AddToCart_Click,
            JSON.stringify(AddCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Status", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW - 1216 Precart - Yuvarani K
const Search_dynamicFormData = (dynamicFormBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_dynamicFormClick,
            JSON.stringify(dynamicFormBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Search_DynamicForm", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW - 1216 Precart - Yuvarani K
const AddCart_Bypass = (AddCartBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_AddToCart_Click,
            JSON.stringify(AddCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AddToCartBypass", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const catfavItem = (catfavItemBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_InsertFavItem,
            JSON.stringify(catfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        //WW-757-Invoke the refresh method in action as there is a delay-Priyanka
                        MenuAction.refreshMasterData();
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const srchcatfavItem = (catfavItemBO) => {
    try {
    
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_InsertFavItem,
            JSON.stringify(catfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        //WW-757-Invoke the refresh method in action as there is a delay-Priyanka
                        MenuAction.refreshMasterData();
                        let contentData = { type: "SrchFavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const NoncatfavItem = (NoncatfavItemBO) => {
    try {
   
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_AddNonCatalogFavItem,
            JSON.stringify(NoncatfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const GetCheaperItem = (KitBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(KitBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Status", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const supplierOrderEntryPageLoad = async (getFavPageBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "workordercheck", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }

                    else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "workorderfail", response: "fail" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

//WW - 1216 Precart - Yuvarani K
export { GetpageLoad, AddCart, catfavItem, NoncatfavItem, AddCart_Bypass, Search_dynamicFormData, GetCheaperItem, supplierOrderEntryPageLoad, ImgaddAttachment, Analytics, srchcatfavItem }
